const state = {
  baseInfos: {}, // 项目详情数据
  settingInfos: {} // 项目配置数据
}

const mutations = {
  SET_BASE_INFOS: (state, val) => {
    state.baseInfos = val
  },
  SET_SETTING_INFOS: (state, val) => {
    state.settingInfos = val
  }
}
const actions = {
  SetBaseInfos ({commit}, data) {
    commit('SET_BASE_INFOS', data)
  },
  SetProjectConfig ({commit}, data) {
    commit('SET_SETTING_INFOS', data)
  }
}
export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/projectSetting.js